import React from 'react'
import { useSelector } from 'react-redux'
import FavoriteCard from '../components/FavoriteCard'
import Masonry from 'react-masonry-css'

function Favorites() {
  const favorites = useSelector(state => state.favorite.favorites)

  const breakpointCols = {
    default: 4,
    1100: 2,
    700: 1
  }

  return (
    <div className="container vh-100 mt-3">
      <h1>My Favorites</h1>
      <hr />
      {
        favorites.length ?
          <Masonry
            breakpointCols={breakpointCols}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {favorites.map(e => 
              <div key={e.artwork.id}>
                <FavoriteCard artwork={e.artwork}/>
              </div>
            )}
          </Masonry>
          :
          null
      }
    </div>
  )
}

export default Favorites